export const CREATE_ORDER = 'CREATE_ORDER';
export const EDIT_ORDER = 'EDIT_ORDER';
export const DELETE_ORDER = 'DELETE_ORDER';
export const SET_ORDERS = 'SET_ORDERS';
